/** Step 6, "Start": when it runs, and the "Start experiment" button below it.
 *  Only "now" for the moment; schedules are coming. */

import { Option } from "@/components/ui/field";
import { Pill } from "@/components/ui/pill";

export function StepSchedule() {
  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="sr-only">When should it run?</legend>
      <Option type="radio" name="ne-schedule" checked readOnly note="Starts as soon as you start it.">
        Once, now
      </Option>
      <Option type="radio" name="ne-schedule" disabled note="Run it again on a regular schedule.">
        <span className="flex items-center gap-2 text-dim">
          On a schedule <Pill>Coming soon</Pill>
        </span>
      </Option>
    </fieldset>
  );
}
